export default __webpack_public_path__ + "static/media/HAT1204.d7dbe481.jpg";